import React from 'react'
import styled from 'styled-components'
import { getCropForAspectRatio } from '../../shared/utils/utils'

const StyledCropPreview = styled.div<{
    originalWidth: number
    originalHeight: number
    renderedWidth: number
}>`
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;
    transform: scale(${props => props.renderedWidth / props.originalWidth});
    width: ${props => props.originalWidth}px;
    height: ${props => props.originalHeight}px;
    border-color: rgba(0, 0, 0, 0.9);
    border-style: solid;
    pointer-events: none;
`

type Props = {
    originalWidth: number
    originalHeight: number
    targetAspectRatio: string
    renderedWidth: number
}

const CropPreview = ({ originalWidth, originalHeight, targetAspectRatio, renderedWidth }: Props) => {
    let cropWidth = originalWidth
    let cropHeight = originalHeight

    if (targetAspectRatio !== 'original') {
        const cropDimensions = getCropForAspectRatio(originalWidth, originalHeight, targetAspectRatio)
        cropWidth = cropDimensions.w
        cropHeight = cropDimensions.h
    }

    return (
        <StyledCropPreview
            {...{
                originalWidth,
                originalHeight,
                renderedWidth,
            }}
            style={{
                borderTopWidth: `${(originalHeight - cropHeight) / 2}px`,
                borderBottomWidth: `${(originalHeight - cropHeight) / 2}px`,
                borderLeftWidth: `${(originalWidth - cropWidth) / 2}px`,
                borderRightWidth: `${(originalWidth - cropWidth) / 2}px`,
            }}
        />
    )
}

export default CropPreview
